export default {
  name: 'marketing-consent',
  props: {
    // { email: Boolean, sms: Boolean, messengers: Boolean, optOut: Boolean }. `optOut` is screen
    // state only and never reaches a request - buildMarketingConsentPayload() reads the channel
    // keys alone, so opting out travels as the three channels all being false, the same payload as
    // leaving everything unticked. The checkout still wants one of the four ticked when "none of
    // it" is on screen (see marketingConsentMissing()); the profile does not. It lives in the value rather than here so the profile can pre-tick it from the saved answers.
    value: {
      type: Object,
      required: true,
    },
    // The channels the published revision carries a wording for, already in the order they are
    // shown in. Each one is { key, apiKey, field, text }.
    channels: {
      type: Array,
      required: true,
    },
    // Optional: the revision may carry no heading, and then none is shown.
    title: {
      type: String,
      default: '',
    },
    // Optional: the wording of "I want none of it". Revisions published before it existed carry
    // none, and then the option is not shown.
    optOut: {
      type: String,
      default: '',
    },
    // Shown under the options; the checkout sets it when the order is sent with none of them ticked.
    error: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggle(key, checked) {
      this.$emit('input', { ...this.value, [key]: checked, ...(checked && { optOut: false }) })
    },
    toggleOptOut(checked) {
      const next = { ...this.value, optOut: checked }
      if (checked) {
        this.channels.forEach((channel) => {
          next[channel.key] = false
        })
      }
      this.$emit('input', next)
    },
  },
}
